import React from "react";

export function getSelectedSem(){

    let selectedSem;
    let selected = document.querySelector('input[type="radio"]:checked');
    if (selected){
         selectedSem= selected.value;
    }
    return (
        selectedSem
    );
}
export function getBacklogStatus(){
    let hasBacklog;
    let selected = document.querySelector('input[type="radio"]:checked');
    if(selected){
        hasBacklog=selected.value;
    }
    return hasBacklog;
}

